import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../js/IncludeManager'
import { GoodsPhoto, GoodsCategory, GoodsFilter, NoResult, Alert } from '../../js/ComponentManager'
import { GoodsDtl } from '../Search/Goods/GoodsDtl';
/* 개발담당:양유빈
 * 화면기능:오늘의 신상 리스트들 
 * 세부설명:
*/

export class HomeBestMore extends Component {
    static displayName = HomeBestMore.name;

    constructor(props) {
        super(props);
        this.state = {
            TotalCount: 0,
            CategoryMid: [],
            CategorySub: [],
            Mid_Cd: "",
            Sub_Cd: "",
            GoodsList: [],
            SearchText:""
        };

        this.AdIndex = Big3Common.Util.GetContentState(this.props, "AdIndex", "");

        
        this.GoodsCategoryRef = React.createRef();
        this.GoodsFilterRef = React.createRef();
        this.refGoodsDtl = React.createRef();

        this.CategoryCallback = this.CategoryCallback.bind(this);
        this.handelFilterInit = this.handelFilterInit.bind(this);
        this.FilterCallback = this.FilterCallback.bind(this);
        this.handleAddMore_Click = this.handleAddMore_Click.bind(this);

        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleSearch_Change = this.handleSearch_Change.bind(this);
        this.handleSearchClear_Click = this.handleSearchClear_Click.bind(this);

        //정렬방식 정의
        if (this.AdIndex === "BestView") {
            this.SearchModel.Order_By = "view_cnt";
        }
    }
    SearchModel = {
        AdIndex: "",
        Man_Cd: "",
        Mid_Cd: "",
        Sub_Cd: "",
        Display: "all",
        Order_By: "reg_dt",
        Start_Price: 0,
        End_Price: 1000000,
        Goods_Nm: "",
        Page_Number: 1,
        Page_Size: Big3Common.WebConfig.Page_Size
    }
    //초기화
    async componentDidMount() {
        this.SearchModel.Page_Number = 1;
        this.CallGetHomeBestMorePage("");
    }
    //엔터 이벤트
    async handleSearch_Click(event) {
        
        if (event.keyCode === 13) {
            if (this.state.SearchText.trim() === "") {
                this.setState({ Title: "상품명을 입력하여 주세요." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            const SearchText = event.target.value;
            this.CallGetHomeBestMorePage(SearchText);
        }
        event.preventDefault();
    }
    //키워드 변경 이벤트
    async handleSearch_Change(event) {
        let Value = event.target.value;
        this.setState({ SearchText: Value });
        event.preventDefault();
    }
    //검색 초기화
    handleSearchClear_Click = async (event) => {
        this.setState({ SearchText: "" });
        this.CallGetHomeBestMorePage("");
        event.preventDefault();
    }
    //데이터 조회
    async CallGetHomeBestMorePage(SearchText, isAppend = false) {
        try {
            Big3Common.Util.LoadingOn();
            this.SearchModel.Goods_Nm = SearchText;
            this.SearchModel.AdIndex = this.AdIndex;
            let Data = await Big3Common.Post('api/AdMgr/HomeAd/GetHomeBestMorePage',
                this.SearchModel, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                const TotalCount = (this.SearchModel.Page_Number * this.SearchModel.Page_Size);
                if (isAppend) {
                    //페이징 처리
                    let GoodListPush = this.state.GoodsList;
                    DataList.map(list => GoodListPush.push(list));
                    this.setState({
                        GoodsList: GoodListPush,
                        TotalCount: TotalCount
                    });
                }
                else {
                    this.setState({
                        GoodsList: DataList,
                        TotalCount: TotalCount
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallSearchGoodsList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //카테고리 클릭
    CategoryCallback(CategoryCd) {
        this.SearchModel.Man_Cd = CategoryCd.Man_Cd;
        this.SearchModel.Mid_Cd = CategoryCd.Mid_Cd;
        this.SearchModel.Sub_Cd = CategoryCd.Sub_Cd;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        this.CallGetHomeBestMorePage(this.state.SearchText);
    }
    //필터조건 검색 Callback 함수
    FilterCallback(Filter) {

        this.SearchModel.Display = Filter.Display;
        this.SearchModel.Order_By = Filter.Order_By;
        this.SearchModel.Start_Price = Filter.Start_Price;
        this.SearchModel.End_Price = Filter.End_Price;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        this.CallGetHomeBestMorePage(this.state.SearchText);
    }
    //필터 초기화
    handelFilterInit() {

        this.GoodsCategoryRef.current.CategoryDataCall();
        this.GoodsFilterRef.current.handleClear_Click();

        this.SearchModel.Man_Cd = "";
        this.SearchModel.Mid_Cd = "";
        this.SearchModel.Sub_Cd = "";
        this.SearchModel.Display = "all";
        this.SearchModel.Order_By = "reg_dt";
        this.SearchModel.Start_Price = 0;
        this.SearchModel.End_Price = 1000000;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        this.CallGetHomeBestMorePage(this.state.SearchText);
    }
    //더보기 클릭
    handleAddMore_Click() {
        this.SearchModel.Page_Number++;
        this.CallGetHomeBestMorePage(this.state.SearchText,true);
    }
    //상품상세보기 클릭
    async handleGoodsDtl_Click(e, goods_no, uid) {
        await this.refGoodsDtl.current.refCallGoodsData(goods_no, uid);
        Big3Common.GoodsDtl_ShowHide(true, true);
    }
    GoodsListrender() {
        const GoodsList = this.state.GoodsList;
        return (
            GoodsList.map((list,idx) =>
                <div className="product" key={idx} onClick={(e) => { this.handleGoodsDtl_Click(e, list.goods_no, list.uid) }}>
                    <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                        Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                        BackGround={true}
                    />
                    <div className="shop_name">{list.whole_name}</div>
                    <div className="product_name">{list.goods_nm}</div>
                    <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                    {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                </div>
            )
        )
    }
    render() {
        const GoodsListrender = this.GoodsListrender();
        return (
            <>
                <div id="child_goods_dtl" className="item_hide">
                    <GoodsDtl
                        ref={this.refGoodsDtl}
                    />
                </div>
                <div id="parent_goods_list">
                    <div className="b_margin d_padding container_box">
                        <div className="search_box seach_box_v2">
                            <input type="search"
                                inputMode="search"
                                placeholder="검색어를 입력해주세요."
                                className="form-control"
                                onKeyUp={(e) => { this.handleSearch_Click(e) }}
                                onChange={this.handleSearch_Change}
                                value={this.state.SearchText}

                            />
                            <div className="search_icon"></div>
                            <div className="search_delete sd2" onClick={(e) => { this.handleSearchClear_Click(e) }}></div>

                        </div>
                        <div className="recent_product result_box">
                            <div className="select_box">
                                <div className="category_box" onClick={(event) => {
                                    Big3Common.ModalAlert(bootstrap, 'GoodsCategory');
                                    event.preventDefault();
                                }}>
                                    <div className="category">카테고리</div>
                                    <div className="category_btn"></div>
                                </div>
                                <div className="category_box filter"
                                    onClick={(event) => {
                                        Big3Common.ModalAlert(bootstrap, 'GoodsFilter');
                                        event.preventDefault();
                                    }}
                                >
                                    <div className="category filter">필터</div>
                                    <div className="category_btn"></div>
                                </div>
                                <div className="category_box reset" onClick={this.handelFilterInit}>
                                    <div className="category">초기화</div>
                                    <div className="reset_btn"></div>
                                </div>
                            </div>
                            <div className="recent_poroducts row row-cols-3 result">
                                {GoodsListrender}
                            </div>
                            {this.state.TotalCount === this.state.GoodsList.length ? <div className="more_btn_box2"><button className="more_btn2" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
                        </div>
                    </div>
                </div>
                <NoResult
                    Visible={this.state.GoodsList.length === 0 ? true : false}
                    Top={"60%"}
                />
                <GoodsCategory
                    id="GoodsCategory"
                    CallBack={this.CategoryCallback}
                    ref={this.GoodsCategoryRef}
                />
                <GoodsFilter
                    id="GoodsFilter"
                    CallBack={this.FilterCallback}
                    ref={this.GoodsFilterRef}
                />
                <Alert
                    id="MessageAlert"
                    title={this.state.Title}
                /> 
            </>
        );
    }
}
